function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.323 8.082c.11-.11.288-.11.398 0l.663.663c.11.11.11.288 0 .398l-7.027 7.027a.281.281 0 01-.398 0l-3.127-3.127a.281.281 0 010-.398l.663-.663c.11-.11.288-.11.398 0l2.265 2.265 6.165-6.165z",
  fill: "currentColor",
  fillRule: "nonzero"
});

var SvgStatusPassedIcon = function SvgStatusPassedIcon(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgStatusPassedIcon;